import { PostAPI } from 'Components/Helper/Helpers';
export const Insert = async (request) => {
    return PostAPI(request, 'CreditRequestMaster/Insert');
};
export const Update = async (request) => {
    return PostAPI(request, 'CreditRequestMaster/Update');
};
export const ActiveORDeActive = async (request) => {
    return PostAPI(request, 'CreditRequestMaster/ActiveORDeActive');
};
export const SelectALL = async (request) => {
    return PostAPI(request, 'CreditRequestMaster/SelectALL');
};
export const SelectByUserID = async (request) => {
    return PostAPI(request, 'CreditRequestMaster/SelectByUserID');
};
export const CreditRequest = async (request) => {
    return PostAPI(request, 'CreditRequestMaster/CreditRequest');
};